import apiClient from '../utils/apiClient';

/**
 * Customer Analytics API Service
 * Phân tích khách mua lại theo món (dựa vào SĐT).
 * Tất cả endpoint đều yêu cầu ADMIN hoặc MANAGER.
 */
export const customerAnalyticsAPI = {
  /**
   * Tổng quan cho header: khách unique, % mua lại, khách loyal, doanh thu loyal, top 5 món.
   */
  getSummary: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-analytics/summary',
      params,
    });
  },

  /**
   * Bảng xếp hạng món theo tỉ lệ mua lại + phân phối (1/2/3/4/5+).
   */
  getProductRepurchase: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-analytics/product-repurchase',
      params,
    });
  },

  /**
   * Top khách đã mua 1 món cụ thể.
   */
  getProductCustomers: async (menuItemId, params = {}) => {
    return await apiClient.get({
      url: `/customer-analytics/product/${encodeURIComponent(menuItemId)}/customers`,
      params,
    });
  },

  /**
   * Lịch sử mua của 1 khách (theo SĐT).
   */
  getCustomerHistory: async (phone, params = {}) => {
    return await apiClient.get({
      url: `/customer-analytics/customer/${encodeURIComponent(phone)}/history`,
      params,
    });
  },

  /**
   * Đóng góp nhân viên vào khách loyal — dùng cho cơ sở chia thưởng.
   */
  getStaffContribution: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-analytics/staff-contribution',
      params,
    });
  },

  /**
   * Đánh giá chiến dịch: phân loại khách mới vs quay lại trong kỳ + top sản phẩm theo segment.
   */
  getCampaignEvaluation: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-analytics/campaign-evaluation',
      params,
    });
  },

  /**
   * Khách quay lại theo chi nhánh: nhóm đặt bàn quay lại + nhóm quay lại không qua đặt bàn,
   * đếm theo NHÓM khách (đã gộp các SĐT từng dùng chung 1 thiết bị).
   */
  getRepeatCustomers: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-analytics/repeat-customers',
      params,
    });
  },

  /**
   * Nhóm khách quen: hình thành/mất theo tháng, tương quan hành vi nhóm mất vs còn, doanh thu dự
   * báo 3 kịch bản, nhóm quay lại sau ba tháng — đúng phép tính của điều tra #233947/#014933.
   */
  getLoyalCohort: async (params = {}) => {
    return await apiClient.get({
      url: '/customer-analytics/loyal-cohort',
      params,
    });
  },
};

export default customerAnalyticsAPI;
